import { RealSource1sojixeyllf40 as RealSource } from './RealSource.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buffered(_this__u8e3s4) {
  return new (RealSource())(_this__u8e3s4);
}
//region block: exports
export {
  buffered as buffered3kq86cdmguv3h,
};
//endregion

//# sourceMappingURL=Core.mjs.map
